"use strict";
/*
NOTES:
The modules in this file has to have leading upper case since the autogenerated file compilator.url.autogen.js
has leading upper case letters in the modules

SHORTHANDS:
$url      - compilator.url

*/
var compilator = compilator || {};
compilator.url = compilator.url || {};

compilator.url._Ajax = function (url, type, options, expectedResultDataType, data) {
  ///<summary>Performs an ajax operation</summary>
  ///<param name="url">Url</param>
  ///<param name="type">Ajax type. Valid values: 'GET', 'POST', 'PUT', 'DELETE'</param>
  ///<param name="options">Ajax override options</param>
  ///<param name="data">Ajax data</param>
  const defaultOptions = {
    url: url,
    type: type,
    cache: false,
    success: function (response) {
      console.log(response);
    },
    error: function (response) {
      $kendo.openKendoErrorDialog(response);
    }
  };

  if (type === "GET") {
    $.extend(defaultOptions, {
      data: data,
      traditional: true
    });
  }
  else {
    $.extend(defaultOptions, {
      data: JSON.stringify(data),
      contentType: "application/json; charset=utf-8"
    });
  }

  if (expectedResultDataType !== undefined) {
    $.extend(defaultOptions, {
      dataType: expectedResultDataType
    });
  }

  $.extend(defaultOptions, options);

  return $.ajax(defaultOptions);
};

var $url = compilator.url;